import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { ExclamationCircleIcon } from 'assets/icons';
import { DataContainer } from 'components/DataContainer';
import { getUserGarageWorkshopId } from 'domains/garage/Garage.store';
import { getDMSConfig } from 'domains/user';
import { DmsInfoWrapper, DmsPic } from 'pages/SettingsPage/Dms/DmsSettings.styled';
import { SectionWrapper } from 'pages/SettingsPage/General/GeneralSettings.styled';
import { theme } from 'styles';
import { Flex, Icon, Spin, SuccessAlert, Text } from 'UI';
import { ERROR } from 'utils';

const DmsCard = () => {
  const { t } = useTranslation();
  const dmsWorkshopId = useSelector(getUserGarageWorkshopId);
  const dmsConfig = useSelector(getDMSConfig);
  const dmsComplementaryData = dmsConfig?.complementaryDmsData;
  const dmsData = dmsComplementaryData?.data;

  return (
    <DataContainer
      data={dmsComplementaryData?.searchStatus}
      Loading={() => (
        <Flex size={0} minWidth={500} justify={'center'} align={'center'}>
          <Spin />
        </Flex>
      )}
      ErrorState={() => (
        <Flex direction={'column'} size={0} minWidth={500}>
          <SectionWrapper displayStyle={ERROR}>
            <Flex direction={'column'} gap={10}>
              <Text type={'h4_paragraph'} displayStyle={ERROR} noWrap>
                {t('settings.configure_dms.not_able_to_connect_with_dms', 'We weren’t able to connect with your DMS')}
              </Text>
              <Text type="base" displayStyle={'error'}>
                {dmsConfig?.errorMessage ?? ''}
              </Text>
              <DmsInfoWrapper padding={15} background={theme.color.error_bg} size={0} gap={15}>
                <DmsPic>
                  <Icon IconComponent={ExclamationCircleIcon} color={theme.color.grey90} />
                </DmsPic>
                <Flex direction={'column'} justify={'center'}>
                  <Text type={'h4_paragraph'} displayStyle={ERROR}>
                    {t('common.error', 'Error')}
                  </Text>
                </Flex>
              </DmsInfoWrapper>
            </Flex>
          </SectionWrapper>
        </Flex>
      )}
    >
      <Flex direction={'column'} size={0} minWidth={500}>
        <SectionWrapper>
          <Flex direction={'column'} gap={10}>
            <Text type={'h4_paragraph'}>{t('settings.configure_dms.linked_to_dms', 'Linked to DMS')}</Text>
            <Text type="base">
              {t('settings.configure_dms.linked_to', 'You are currently linked to {{dmsWorkshopId}}', {
                dmsWorkshopId: dmsWorkshopId ?? '...',
              })}
            </Text>
            <DmsInfoWrapper padding={15} background={theme.color.grey90} size={0} gap={15}>
              <DmsPic />
              <Flex direction={'column'} justify={'center'}>
                <Text type={'h4_paragraph'}>{t('settings.configure_dms.dms_name', 'DMS NAME')}</Text>
                <Text type="base">
                  {t('settings.configure_dms.dms_complementary_data.editor', 'EDITOR: {{editor}}', {
                    editor: dmsData?.editor ?? '',
                  })}
                </Text>
                <Text type="base">
                  {t('settings.configure_dms.dms_complementary_data.tool', 'TOOL: {{tool}}', {
                    tool: dmsData?.tool ?? '',
                  })}
                </Text>
                <Text type="base">
                  {t('settings.configure_dms.dms_complementary_data.tool_version', 'TOOL VERSION: {{toolVersion}}', {
                    toolVersion: dmsData?.toolVersion ?? '',
                  })}
                </Text>
              </Flex>
            </DmsInfoWrapper>
          </Flex>
        </SectionWrapper>
        <SuccessAlert
          size={'lg'}
          message={
            <Flex direction={'column'} padding={'0 0 0 15px'}>
              <Text type={'h4_paragraph'}>{t('common.connected', 'Connected')}</Text>
              <Text type="base">
                {t('settings.configure_dms.successfully_connected_to_dms', 'You were successfully linked to DMS')}
              </Text>
            </Flex>
          }
        />
      </Flex>
    </DataContainer>
  );
};

export default DmsCard;
